/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit',
	'@ba/ba-ui-carbon',
	'../app/nls/StringResources',
	'./PinsListView'

], function(React, PropTypes, UI_CARBON_TOOLKIT, UI_CARBON, StringResources, PinsListView) {

	const { SearchInput,
		TruncatedText,
		Container,
		FlexItem } = UI_CARBON_TOOLKIT;
	const { Dropdown } = UI_CARBON;
	const keyNames = UI_CARBON_TOOLKIT.keyboardUtils.keyNames;

	class PinsPanelView extends React.Component {
		constructor(props){
			super(props);
			this.state = {
				searchText: '',
				pins: this.props.dashboardPinningService.getCachedPins('all')
			};
			this.searchInput = React.createRef();
			this.triggerButton = React.createRef();
			this.filterOptions = [
				{ value: 'all', text: StringResources.get('pinDateFilterAll') },
				{ value: 'today', text: StringResources.get('pinDateFilterToday') },
				{ value: 'yesterday', text: StringResources.get('pinDateFilterYesterday') },
				{ value: 'pastWeek', text: StringResources.get('pinDateFilterPastWeek') },
				{ value: 'pastMonth', text: StringResources.get('pinDateFilterPastMonth') },
				{ value: 'earlier', text: StringResources.get('pinDateFilterEarlier') }
			];
			this.filterItem = this.filterOptions[0];

		}

		componentDidMount(){
			this.addHandler = this.props.dashboardPinningService.on('pin:created', this.updatePinsState.bind(this));
			this.searchInput.current.focus();
		}

		componentWillUnmount() {
			this.addHandler.remove();
		}

		updatePinsState() {
			this.setState({ pins : this.props.dashboardPinningService.getCachedPins(this.filterItem.value) });
		}

		updateFilterText(filterItem) {
			this.filterItem = filterItem.selectedItem;
			this.updatePinsState();
		}

		onPinDeleted(pinId, event) {
			this.props.dashboardPinningService.deletePin(pinId, () => { this.updatePinsState(); })
				.catch(() => {
					this.updatePinsState();
				});
			this.updatePinsState();
			event.stopPropagation();
		}

		onPinRename(pinId, newName) {
			if (newName) {
				this.props.dashboardPinningService.renamePin(pinId, newName, () => { this.updatePinsState(); })
					.then(() => {
						this.updatePinsState();
					});
			}
		}

		getPinById(pinId, array) {
			return array.filter((pin) => pin.id === pinId)[0];
		}

		onKeyDown (id, event) {
			if(event.key.toUpperCase() === keyNames.ENTER){
				this.props.addPinToCanvas(id, event);
			} else if (event.key.toUpperCase() === keyNames.BACKSPACE) {
				this.onPinDeleted(id, event);
			}
		}

		renderList() {
			return (
				<PinsListView
					items = {this.state.pins}
					onKeyDown = {this.onKeyDown.bind(this)}
					onPinDeleted = {(pinId, event) => this.onPinDeleted(pinId, event)}
					onPinRename = {(pinId, newName) => this.onPinRename(pinId, newName)}
					searchText = {this.state.searchText}
					smartNamingSvc = {this.props.smartNamingSvc}
					handleClick = {this.props.addPinToCanvas}
				/>
			);
		}

		renderSearchView() {
			return (
				<SearchInput
					className={'searchArea'}
					value = {this.state.searchText}
					hideLeftIcon = {false}
					placeholder = {StringResources.get('searchPanel')}
					onChange = { (userInput) => {this.setState({ searchText: userInput });}}
					ref = {this.searchInput}
					size = 'sm'
				/>
			);
		}

		renderFilter() {
			return (
				<Dropdown
					ariaLabel={StringResources.get('dropdownAriaLabel')}
					className='filterPinsDropdown'
					id='filter-pins-dropdown'
					items={this.filterOptions}
					itemToString={(item) => (item ? item.text : '')}
					onChange = { this.updateFilterText.bind(this) }
					selectedItem={this.filterItem}
					width={180}
				/>
			);
		}

		render(){
			return(
				<Container className={'pinView'}>
					<FlexItem className='pinHeaderContainer'>
						<TruncatedText className='pinHeader' value={StringResources.get('pinsOld')} style={{ width:120 }}/>
						{this.renderFilter()}
					</FlexItem>
					<Container className={'pinListView'}>
						{this.renderSearchView()}
						{this.renderList()}
					</Container>
				</Container>
			);
		}
	}

	PinsPanelView.propTypes = {
		addPinToCanvas: PropTypes.function,
		smartNamingSvc: PropTypes.object,
		dashboardPinningService: PropTypes.object
	};

	return PinsPanelView;
});